<template>
  <div>
    <custom-select
      :value="selectedValues"
      :multiple="multiple"
      :disabled="disabled"
      :outlined="outlined"
      :show-actions="false"
      :show-clear-action="showClearAction"
      @input="(items) => onSelect(items)"
      @clear="onClear"
      :items="countries"
      :autofocus="true"
      v-bind="$attrs"
      :loading="loading"
      :chips-code-display="chipsCodeDisplay"
    >
      <template v-slot:item="slotProps">
        <slot name="item" v-bind="slotProps">
          <v-list-item-content class="counties-content d-flex">
            <div class="counties-content-wrapper">
              <v-list-item-icon class="counties-content-wrapper-icon">
                <slot name="icon">
                  <lang-circle :country="slotProps.item.value"></lang-circle>
                </slot>
              </v-list-item-icon>
              <v-list-item-title class="counties-content-title">
                <slot v-bind="slotProps" name="title">
                  {{ slotProps.item.text }}({{ slotProps.item.fullName }})
                </slot>
              </v-list-item-title>
            </div>
          </v-list-item-content>
        </slot>
      </template>
    </custom-select>
  </div>
</template>

<script>
  import CustomSelect from '@/modules/proxers/CustomSelect.vue'
  import LangCircle from '@/components/core/SelectLang/LangRow/LangCircle.vue'

  export default {
    name: 'SelectCountries',
    components: { LangCircle, CustomSelect },
    data () {
      return {
        selectedItems: this.multiple ? [] : {},
      }
    },
    props: {
      multiple: {
        type: Boolean,
        default: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      outlined: {
        type: Boolean,
        default: true
      },
      countries: {
        type: [ Object, Number, String, Array ],
        require: true
      },
      chosenCountries: {
        type: [ Object, Number, String, Array ],
        require: true
      },
      staticCountries: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      showClearAction: {
        type: Boolean,
        default: false
      },
      chipsCodeDisplay: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      selectedValues () {
        if (this.multiple) {
          const selected = this.selectedItems?.map(({ text }) => text)
          return selected.length ? selected : this.foundValue?.map(({ text }) => text)
        }
        return this.selectedItems?.text || this.foundValue?.text
      },
      foundValue () {
        return this.multiple
          ? this.countries.filter(({ value }) => this.chosenCountries.includes(value))
          : this.countries.find(({ value }) => this.chosenCountries === value)
      },
    },
    watch: {
      chosenCountries (newVal) {
        this.selectedItems = this.multiple ? [] : {}
      }
    },
    methods: {
      onSelect (items) {
        this.selectedItems = this.staticCountries ? this.selectedItems : items
        this.$emit('input', items)
      },
      onClear () {
        this.selectedItems = this.multiple ? [] : {}
        this.$emit('clear')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .counties-content {
    display: flex;
    padding: 8px 0 8px 0;

    &-wrapper {
      height: 26px;

      &-icon {
        margin: 0 8px 0 4px !important;
      }
    }

    &-title {
      display: inline-block;
      margin-bottom: 3px;
      text-overflow: ellipsis;
      max-width: 125px;
    }
  }
</style>
